module.exports = __webpack_public_path__ + "static/assets/img/hesperites.42cb6afb.png";